// src/beta/services/matchingComponents.ts
import { betaFetch } from '@/beta/services/api';
import type { V1MatchingComponent } from '@/beta/types/dossier';

interface Resp {
  version: 1;
  vehicle_id: string;
  data: { components: V1MatchingComponent[] };
  generated_at: string;
}

export async function getMatchingComponents(vehicleId: string) {
  const res = await betaFetch<Resp>(`/vehicles/${vehicleId}/matching-components`);
  return res.data;
}
